import React from "react";
import { Box, Flex, HStack, Heading, Icon, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";
import { drgba } from "../../../components/glassUi";

interface SecurityCardProps {
  icon: IconType;
  title: string;
  subtitle?: React.ReactNode;
  accent?: string; // główny kolor karty (hex 6-znakowy), domyślnie primary
  badge?: React.ReactNode; // plakietka statusu obok tytułu
  action?: React.ReactNode; // slot po prawej (switch/link/spinner)
  full?: boolean; // rozciągnij na całą szerokość gridu
  danger?: boolean;
  children?: React.ReactNode;
}

/**
 * Wspólna premium karta Centrum Bezpieczeństwa: gradientowy chip ikony, tytuł + opis, status, akcja po prawej,
 * subtelny hover-lift. Każde zabezpieczenie ma własną ikonę i akcent — spójny, bogaty system.
 */
export const SecurityCard: React.FC<SecurityCardProps> = ({
  icon,
  title,
  subtitle,
  accent = "#430098",
  badge,
  action,
  full,
  danger,
  children
}) => {
  const ac = danger ? "#E51F44" : accent;
  return (
    <Box
      borderRadius="18px"
      p={{ base: "18px", md: "20px" }}
      gridColumn={full ? { md: "1 / -1" } : undefined}
      bg={danger ? "rgba(229,31,68,0.05)" : "rgba(24,12,48,0.028)"}
      border={danger ? `1px solid ${drgba("#e51f44", 0.18)}` : undefined}
    >
      <Flex align="flex-start" gap="14px" mb={children ? "16px" : "0"}>
        <Flex
          w="46px"
          h="46px"
          borderRadius="14px"
          flexShrink={0}
          align="center"
          justify="center"
          color={ac}
          bg={drgba(ac, 0.12)}
        >
          <Icon as={icon} boxSize="22px" />
        </Flex>
        <Box flex="1" minW={0}>
          <HStack spacing="9px" mb="3px" wrap="wrap">
            <Heading fontSize="17px" fontWeight="800" color={danger ? "#E51F44" : "#241536"} lineHeight="1.2" letterSpacing="-0.01em">
              {title}
            </Heading>
            {badge}
          </HStack>
          {subtitle && (
            <Text fontSize="13.5px" color="#8a8397" lineHeight="1.5">
              {subtitle}
            </Text>
          )}
        </Box>
        {action && (
          <Box flexShrink={0} pt="2px">
            {action}
          </Box>
        )}
      </Flex>
      {children}
    </Box>
  );
};
